<div>
  <div class="text-xs mb-10 space-y-2">
    <p>Utilize o campo abaixo para adicionar o seu número de telefone</p>
  </div>

  <form method="POST" class="space-y-4" [formGroup]="form">

    <div class="space-y-8">

      <div class="my-4">
        <div class="mt-5">
          <app-phone-number-field>
            <app-text-input [formGroup]="form" type="number" id="phoneNumber" [maxLength]="9"
              [value]="form.value?.phoneNumber"
            placeholder="Contacto Telefónico" label="Contacto Telefónico"></app-text-input>
          </app-phone-number-field>
        </div>

        <div class="my-2">
          @if (formErrors.get('phoneNumber')) {
            <app-form-error
            [message]="formErrors.get('phoneNumber')"></app-form-error>
          }
        </div>

        <div class="my-4">
          <app-ae-button variant="primary" label="Solicitar Código de Validação" [loading]="isLoadingPhoneNumberValCodeReq"
            [disabled]="!form.get('phoneNumber')?.value" size="sm" styleClass="w-full"
          (buttonClick)="apiRequestPhoneNumberCode()"></app-ae-button>
        </div>

      </div>

      <div class="mt-2">
        <app-text-input [formGroup]="form" type="number" id="phoneValidationCode" [maxLength]="9"
          [value]="form.value?.phoneValidationCode"
        placeholder="Código de Validação" label="Código de Validação"></app-text-input>
      </div>

    </div>
    <!-- submit button -->
    <div class="my-4">
      <app-ae-button variant="primary" label="Adicionar Número" [disabled]="!form.valid" [loading]="isLoadingPhoneNumberAdd"
      (buttonClick)="apiAddPhoneNumber()" size="sm" styleClass="w-full"></app-ae-button>
    </div>
  </form>
</div>
